import { render, staticRenderFns } from "./SocialGrouped.vue?vue&type=template&id=6664e5fe&"
import script from "./SocialGrouped.vue?vue&type=script&lang=js&"
export * from "./SocialGrouped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports